export default __webpack_public_path__ + "fe5193973257e47d061bcc443b9eec9d.png";